import {EvaluationSection} from "../../javascript.lib.mojo-base/model/module/EvaluationSection";
import {FacilityEvaluationSections2} from "./FacilityEvaluationSections2";


export class FacilityEvaluationSections3 {

  static readonly evaluationSections: EvaluationSection[] = FacilityEvaluationSections2.evaluationSections;

}
